import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BaseUrl } from '../App';
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


const Tooltip = () => {
  const [isExpanded, setIsExpanded] = useState(false);
   const [loading, setLoading] = useState(false);

  const [settings, setSettings] = useState({
    ct_front_tool_tips_my_bookings: '',
    ct_front_tool_tips_postal_code: '',
    ct_front_tool_tips_services: '',
    ct_front_tool_tips_addons_services: '',
    ct_front_tool_tips_frequently_discount: '',
    ct_front_tool_tips_time_slots: '',
    ct_front_tool_tips_personal_details: '',
    ct_front_tool_tips_promocode: '',
    ct_front_tool_payment_method: '',
  });

  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("")
  const toggle = () => setIsExpanded(!isExpanded);
  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);
  // Fetch settings directly using axios in useEffect
  // useEffect(() => {
  //   setLoading(true);

  //   axios.post(`${BaseUrl}/backend/api/settings.php`, {
  //     action: 'get_all_settings',
  //     api_key: '1',
  //   })
  //   .then((response) => {
  //     const data = response.data;

  //     console.log('Fetched all settings:', data);

  //     if (data.status === 'true' && data.statuscode === 200) {
  //       const allSettings = data.response;

  //       // Filter the specific settings you need
  //       const specificSettings = allSettings.reduce((acc, setting) => {
  //         if ([
  //           "ct_front_tool_tips_my_bookings",
  //           "ct_front_tool_tips_postal_code",
  //           "ct_front_tool_tips_services",
  //           "ct_front_tool_tips_addons_services",
  //           "ct_front_tool_tips_frequently_discount",
  //           "ct_front_tool_tips_time_slots",
  //           "ct_front_tool_tips_personal_details",
  //           "ct_front_tool_tips_promocode",
  //           "ct_front_tool_payment_method"
  //         ].includes(setting.option_name)) {
  //           acc[setting.option_name] = setting.option_value || '';
  //         }
  //         return acc;
  //       }, {});

  //       setSettings(specificSettings);
  //     } else {
  //       console.error('Failed to fetch specific settings:', data.response);
  //     }
  //   })
  //   .catch((error) => {
  //     console.error('Error fetching all settings:', error);
  //     setError('Failed to fetch settings. Please try again later.');
  //   }  finally {
  //     setLoading(false);
  //   }
  
  // );
  // }, []);

  useEffect(() => {
  setLoading(true);

  axios.post(`${BaseUrl}/backend/api/settings.php`, {
    action: 'get_all_settings',
    api_key: '1',
  })
  .then((response) => {
    const data = response.data;

    console.log('Fetched all settings:', data);

    if (data.status === 'true' && data.statuscode === 200) {
      const allSettings = data.response;

      // Filter the specific settings you need
      const specificSettings = allSettings.reduce((acc, setting) => {
        if ([
          "ct_front_tool_tips_my_bookings",
          "ct_front_tool_tips_postal_code",
          "ct_front_tool_tips_services",
          "ct_front_tool_tips_addons_services",
          "ct_front_tool_tips_frequently_discount",
          "ct_front_tool_tips_time_slots",
          "ct_front_tool_tips_personal_details",
          "ct_front_tool_tips_promocode",
          "ct_front_tool_payment_method"
        ].includes(setting.option_name)) {
          acc[setting.option_name] = setting.option_value || '';
        }
        return acc;
      }, {});

      setSettings(specificSettings);
    } else {
      console.error('Failed to fetch specific settings:', data.response);
    }
  })
  .catch((error) => {
    console.error('Error fetching all settings:', error);
    setError('Failed to fetch settings. Please try again later.');
  })
  .finally(() => {
    setLoading(false);
  });
}, []);


  // Save the settings using axios
  const handleSave = async () => {
    let updateSuccess = true;
    for (const [key, value] of Object.entries(settings)) {
      try {
        const success = await updateSetting(key, value);
        if (!success) {
          updateSuccess = false;
          break;
        }
      } catch (error) {
        updateSuccess = false;
        console.error(`Error updating ${key}:`, error);
        break;
      }
    }

    if (updateSuccess) {
      console.log('All settings updated successfully.');
    } else {
      console.error('Failed to update some settings.');
    }
  };

  // Handle individual setting updates using axios
  const updateSetting = async (optionName, optionValue) => {
    setLoading(true);

    try {
      console.log(`Updating setting: ${optionName} with value: ${optionValue}`);
      const response = await axios.post(`${BaseUrl}/backend/api/settings.php`, {
        action: 'update_setting',
        api_key: '1',
        option_name: optionName,
        option_value: optionValue ?? '',
      });

      console.log('Backend Response:', response.data);

      if (response.data.status === 'true' && response.data.statuscode === 200) {
        setSuccessMessage(`Updated ${optionName} successfully`);
        console.log(`Updated ${optionName} successfully`);
        return true;
      }
      throw new Error(response.data.response || `Failed to update ${optionName}`);
    } catch (error) {
      console.error(`Error updating ${optionName}:`, error);
      setError(error.response?.data?.message || error.message || `Failed to update ${optionName}`);
      return false;
    }   finally {
      setLoading(false);
    }
  };

  // Handle input field change
  const handleChange = (key, value) => {
    setSettings((prevSettings) => ({
      ...prevSettings,
      [key]: value,
    }));
  };

  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
    <div className="mx-auto mt-8 xl:px-72">
           {successMessage && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{successMessage}</span>
        </div>
      )}

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{error}</span>
        </div>
      )}

      <div className="flex items-center justify-between">
        <span className="text-gray-700 font-bold text-xl">Front Tool Tips</span>
        <button
          onClick={toggle}
          className={`relative w-12 h-6 rounded-full transition-all duration-500 flex items-center justify-start ${
            isExpanded ? 'bg-green-500 text-white' : 'bg-gray-300 text-gray-600'
          }`}
        >
          <div
            className={`w-6 h-6 bg-white rounded-full absolute transition-all ${
              isExpanded ? 'right-0.5' : 'left-0.5'
            }`}
          />
        </button>
      </div>

      <div
        className={`overflow-hidden transition-all mt-10 duration-1000 ease-in-out`}
        style={{
          height: isExpanded ? 'auto' : '0',
          opacity: isExpanded ? '1' : '0',
          paddingTop: isExpanded ? '10px' : '0',
          paddingBottom: isExpanded ? '10px' : '0',
        }}
      >
        {isExpanded && (
          <div>
            {Object.keys(settings).map((key, index) => (
              <div className="mt-6" key={index}>
                <label htmlFor={key} className="block text-gray-700 font-medium">
                  {key.replace(/_/g, ' ')}
                </label>
                <input
                  id={key}
                  type="text"
                  value={settings[key]}
                  onChange={(e) => handleChange(key, e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            ))}

            {error && <div className="text-red-500">{error}</div>}

            <div className="mt-4">
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
              >
                Save
              </button>
            </div>
          </div>
        )}
      </div>
    </div>

  </div>
  );
};

export default Tooltip;

// import axios from 'axios';

// const Tooltip = () => {
//   const [isExpanded, setIsExpanded] = useState(false);
//   const [settings, setSettings] = useState({
//     ct_front_tool_tips_my_bookings: '',
//     ct_front_tool_tips_postal_code: '',
//     ct_front_tool_tips_services: '',
//     ct_front_tool_tips_addons_services: '',
//     ct_front_tool_tips_frequently_discount: '',
//     ct_front_tool_tips_time_slots: '',
//     ct_front_tool_tips_personal_details: '',
//     ct_front_tool_tips_promocode: '',
//     ct_front_tool_payment_method: '',
//   });

//   const [error, setError] = useState(null);

//   const toggle = () => setIsExpanded(!isExpanded);

//   // Fetch settings directly using axios in useEffect
//   useEffect(() => {
//     axios.post('http://10.27.1.112:80/megaclean/backend/api/settings.php', {
//       action: 'get_all_settings',
//       api_key: '1',
//     })
//     .then((response) => {
//       const data = response.data;

//       console.log('Fetched all settings:', data);

//       if (data.status === 'true' && data.statuscode === 200) {
//         const allSettings = data.response;

//         // Filter the specific settings you need
//         const specificSettings = allSettings.reduce((acc, setting) => {
//           if ([
//             "ct_front_tool_tips_my_bookings",
//             "ct_front_tool_tips_postal_code",
//             "ct_front_tool_tips_services",
//             "ct_front_tool_tips_addons_services",
//             "ct_front_tool_tips_frequently_discount",
//             "ct_front_tool_tips_time_slots",
//             "ct_front_tool_tips_personal_details",
//             "ct_front_tool_tips_promocode",
//             "ct_front_tool_payment_method"
//           ].includes(setting.option_name)) {
//             acc[setting.option_name] = setting.option_value || '';
//           }
//           return acc;
//         }, {});

//         setSettings(specificSettings);
//       } else {
//         console.error('Failed to fetch specific settings:', data.response);
//       }
//     })
//     .catch((error) => {
//       console.error('Error fetching all settings:', error);
//       setError('Failed to fetch settings. Please try again later.');
//     });
//   }, []);

//   // Save the settings using axios
//   const handleSave = async () => {
//     let updateSuccess = true;
//     for (const [key, value] of Object.entries(settings)) {
//       try {
//         const success = await updateSetting(key, value);
//         if (!success) {
//           updateSuccess = false;
//           break;
//         }
//       } catch (error) {
//         updateSuccess = false;
//         console.error(`Error updating ${key}:`, error);
//         break;
//       }
//     }

//     if (updateSuccess) {
//       console.log('All settings updated successfully.');
//     } else {
//       console.error('Failed to update some settings.');
//     }
//   };

//   // Handle individual setting updates using axios
//   const updateSetting = async (optionName, optionValue) => {
//     try {
//       console.log(`Updating setting: ${optionName} with value: ${optionValue}`);
//       const response = await axios.post('http://10.27.1.112:80/megaclean/backend/api/settings.php', {
//         action: 'update_setting',
//         api_key: '1',
//         option_name: optionName,
//         option_value: optionValue ?? '',
//       });

//       console.log('Backend Response:', response.data);

//       if (response.data.status === 'true' && response.data.statuscode === 200) {
//         console.log(`Updated ${optionName} successfully`);
//         return true;
//       }
//       throw new Error(response.data.response || `Failed to update ${optionName}`);
//     } catch (error) {
//       console.error(`Error updating ${optionName}:`, error);
//       setError(error.response?.data?.message || error.message || `Failed to update ${optionName}`);
//       return false;
//     }
//   };

//   // Handle input field change
//   const handleChange = (key, value) => {
//     setSettings((prevSettings) => ({
//       ...prevSettings,
//       [key]: value,
//     }));
//   };

//   return (
//     <div className="mx-auto mt-8 xl:px-72">
//       <div className="flex items-center justify-between">
//         <span className="text-gray-700 font-bold text-xl">Front Tool Tips</span>
//         <button
//           onClick={toggle}
//           className={`relative w-12 h-6 rounded-full transition-all duration-500 flex items-center justify-start ${
//             isExpanded ? 'bg-green-500 text-white' : 'bg-gray-300 text-gray-600'
//           }`}
//         >
//           <div
//             className={`w-6 h-6 bg-white rounded-full absolute transition-all ${
//               isExpanded ? 'right-0.5' : 'left-0.5'
//             }`}
//           />
//         </button>
//       </div>

//       <div
//         className={`overflow-hidden transition-all mt-10 duration-1000 ease-in-out`}
//         style={{
//           height: isExpanded ? 'auto' : '0',
//           opacity: isExpanded ? '1' : '0',
//           paddingTop: isExpanded ? '10px' : '0',
//           paddingBottom: isExpanded ? '10px' : '0',
//         }}
//       >
//         {isExpanded && (
//           <div>
//             {Object.keys(settings).map((key, index) => (
//               <div className="mt-6" key={index}>
//                 <label htmlFor={key} className="block text-gray-700 font-medium">
//                   {key.replace(/_/g, ' ')}
//                 </label>
//                 <input
//                   id={key}
//                   type="text"
//                   value={settings[key]}
//                   onChange={(e) => handleChange(key, e.target.value)}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//             ))}

//             {error && <div className="text-red-500">{error}</div>}

//             <div className="mt-4">
//               <button
//                 onClick={handleSave}
//                 className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
//               >
//                 Save
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Tooltip;



// import React, { useState } from 'react';

// const Tooltip = () => {
//   const [isExpanded, setIsExpanded] = useState(false);
//   const [testMode, setTestMode] = useState(false);
//   const [clientId, setClientId] = useState('');
//   const [clientSecret, setClientSecret] = useState('');

//   const toggle = () => {
//     setIsExpanded(!isExpanded); // Toggle the state
//   };

//   const toggleTestMode = () => {
//     setTestMode(!testMode);
//   };

//   const handleSave = () => {
//     // Simulate saving the data
//     console.log('Saved Client ID:', clientId);
//     console.log('Saved Client Secret:', clientSecret);
//     console.log('Test Mode:', testMode);

//     // Reset all fields after saving
//     setClientId('');
//     setClientSecret('');
//     setTestMode(false);
   
//   };

//   return (
//     <div className="mx-auto mt-8  xl:px-72">
//       <div className="flex items-center justify-between">
//   {/* Title Section */}
//   <span className="text-gray-700 font-bold text-xl">
//   Front Tool Tips  </span>

//   {/* Toggle Button */}
//   <button
//     onClick={toggle}
//     className={`relative w-12 h-6 rounded-full transition-all duration-500 flex items-center justify-start ${isExpanded ? 'bg-green-500 text-white' : 'bg-gray-300 text-gray-600'}`}
//   >
//     <div
//       className={`w-6 h-6 bg-white rounded-full absolute transition-all ${isExpanded ? 'right-0.5' : 'left-0.5'}`}
//     />
//   </button>
// </div>


//       <div
//         className={`overflow-hidden transition-all mt-10 duration-1000 ease-in-out`}
//         style={{
//           height: isExpanded ? 'auto' : '0', // Control height for smooth transition
//           opacity: isExpanded ? '1' : '0', // Fade in/out
//           paddingTop: isExpanded ? '10px' : '0', // Adjust padding to smooth transition
//           paddingBottom: isExpanded ? '10px' : '0', // Adjust padding to smooth transition
//         }}
//       >
//         {isExpanded && (
//           <div>
//             <div>
//               <label htmlFor="clientId" className="block text-gray-700 font-medium ">
//               My Bookings
//               </label>
//               <input
//                 id="clientId"
//                 type="text"
//                 value={clientId}
//                 onChange={(e) => setClientId(e.target.value)} // Handle input change
//                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 "
//               />
//             </div>
//             <div className='mt-6'>
//               <label htmlFor="clientSecret" className="block text-gray-700 font-medium">
//               Postal Code
//               </label>
//               <input
//                 id="clientSecret"
//                 type="text"
//                 value={clientSecret}
//                 onChange={(e) => setClientSecret(e.target.value)} // Handle input change
//                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//               />
//             </div>
//             <div className='mt-6'>
//               <label htmlFor="clientSecret" className="block text-gray-700 font-medium">
//               Services
//               </label>
//               <input
//                 id="clientSecret"
//                 type="text"
//                 value={clientSecret}
//                 onChange={(e) => setClientSecret(e.target.value)} // Handle input change
//                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//               />
//             </div>
//             <div className='mt-6'>
//               <label htmlFor="clientSecret" className="block text-gray-700 font-medium">
//               Extra service
//               </label>
//               <input
//                 id="clientSecret"
//                 type="text"
//                 value={clientSecret}
//                 onChange={(e) => setClientSecret(e.target.value)} // Handle input change
//                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//               />
//             </div>
//             <div className='mt-6'>
//               <label htmlFor="clientSecret" className="block text-gray-700 font-medium">
//               Frequently discount
//               </label>
//               <input
//                 id="clientSecret"
//                 type="text"
//                 value={clientSecret}
//                 onChange={(e) => setClientSecret(e.target.value)} // Handle input change
//                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//               />
//             </div>
//             <div className='mt-6'>
//               <label htmlFor="clientSecret" className="block text-gray-700 font-medium">
//               When would you like us to come?
//               </label>
//               <input
//                 id="clientSecret"
//                 type="text"
//                 value={clientSecret}
//                 onChange={(e) => setClientSecret(e.target.value)} // Handle input change
//                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//               />
//             </div>
//             <div className='mt-6'>
//               <label htmlFor="clientSecret" className="block text-gray-700 font-medium">
//               Your Personal Details
//               </label>
//               <input
//                 id="clientSecret"
//                 type="text"
//                 value={clientSecret}
//                 onChange={(e) => setClientSecret(e.target.value)} // Handle input change
//                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//               />
//             </div>
//             <div className='mt-6'>
//               <label htmlFor="clientSecret" className="block text-gray-700 font-medium">
//               Have A Promocode
//               </label>
//               <input
//                 id="clientSecret"
//                 type="text"
//                 value={clientSecret}
//                 onChange={(e) => setClientSecret(e.target.value)} // Handle input change
//                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//               />
//             </div>
//             <div className='mt-6'>
//               <label htmlFor="clientSecret" className="block text-gray-700 font-medium">
//               Preferred Payment Method
//               </label>
//               <input
//                 id="clientSecret"
//                 type="text"
//                 value={clientSecret}
//                 onChange={(e) => setClientSecret(e.target.value)} // Handle input change
//                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//               />
//             </div>

          

//             {/* Save Button */}
//             <div className="mt-4">
//               <button
//                 onClick={handleSave}
//                 className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
//               >
//                 Save
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Tooltip;
